import { GET } from "../../APiHelper/API";

export const getDeletedTeamsForLeaagueAPI = (league_id, onSuccess, onError) => {
    GET(`/api/v1/leagues/${league_id}/deleted_teams`, onSuccess, onError);
};
